enum NotificationEventTypeId {
  AlertTriggered = 1,
  SystemEfficiencyAlert = 2,
  NewThermostatInstalled = 3,
  PerformanceTestIssue = 4,
  SubscriptionPlanChanged = 5,
  ThermostatOffline = 6,
  MonthlyEngagementReport = 7,
  PerformanceTestStopped = 8,
}

export default NotificationEventTypeId
